<template>
  <div class="sonFlexEvent">
    <div class="flexAuto">
      <div class="flexTop">
        <div class="flexTitle">账户信息</div>
        <div class="flexCon">
          <div class="flexConDou">
            <div class="picture">
              <i class="iconfont icon-yue"></i>
            </div>
            <div class="Account">
              <div class="AccountContent">
                <p>账户余额</p>
                <p>{{ EcoinObj.balance }}<span class="Especially">元</span></p>
              </div>
            </div>
            <div class="Button">
              <!-- <Button style="margin: 0 10px;" @click="handleCharge">在线充值</Button> -->
              <AddAccounts @onChange="upData" :type="'0'">
                <Button type="primary" class="iViewButton" @click="handleAccounts">转账充值</Button>
              </AddAccounts>
            </div>
            <div class="Account">
              <div class="AccountContent">
                <p style="font-size: 15px;">累计转账充值</p>
                <p style="font-size: 17px;margin-top: 9px;">{{ EcoinObj.offLineAmount }}<span class="Especially">元</span></p>
              </div>
            </div>
            <div class="Account">
              <div class="AccountContent">
                <p style="font-size: 15px;">累计在线充值</p>
                <p style="font-size: 17px;margin-top: 9px;">{{ EcoinObj.onLineAmount }}<span class="Especially">元</span></p>
              </div>
            </div>
            <div class="Account">
              <div class="AccountContent">
                <p style="font-size: 15px;">累计消费</p>
                <p style="font-size: 17px;margin-top: 9px;">{{ EcoinObj.payTotalAmount }}<span class="Especially">元</span></p>
              </div>
            </div>
          </div>
          <!-- <div class="Button">
            <div class="Icon">
              <i class="iconfont icon-tixing2"></i>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddAccounts from '../AddAccounts.vue';
export default {
  name: 'Ecoin',
  components: {
    AddAccounts
  },
  props: {
    EcoinObj: Object
  },
  data () {
    return {
    }
  },
  methods: {
    upData () {
      this.$emit('onChange')
    },
    handleCharge () {
      this.$router.push({ name: `Charge` });
    },
    handleAccounts () {

    }
  }
}
</script>

<style lang="less" scoped>
.sonFlexEvent{
  width: 100%;
  .flexAuto{
    .flexTop{
      width: 100%;
      height: 153px;
      border: 1px solid #e5e5e5;
      .flexTitle{
        width: 100%;
        height: 39px;
        line-height: 39px;
        background: #f4f5f9;
        text-indent: 20px;
        font-size: 14px;
        color: #1a1a1a;
        border-bottom: 1px solid #e5e5e5;
      }
      .flexCon{
        width: 100%;
        height: 112px;
        .flexConDou{
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-around;
          .picture{
            line-height: 112px;
            margin-left: 30px;
            flex: 1;
            i{
              font-size: 34px;
              color: #ffc310;
            }
          }
          .Account{
            flex: 2;
            .AccountContent{
              margin-top: 20px;
              p:first-child{
                font-size: 16px;
              }
              p:nth-child(2){
                font-size: 20px;
                font-weight: bold;
                margin-top: 3px;
                .Especially{
                  font-weight: normal;
                  font-size: 15px;
                  margin-left: 5px;
                }
              }
            }
          }
          .Button{
            line-height: 112px;
            flex: 3;
            text-align: right;
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }
}
</style>
